import {QueryClient, QueryClientProvider, DefaultOptions} from '@tanstack/react-query'
import React, {Suspense} from 'react'

const ReactQueryDevtools =
  process.env.NODE_ENV === 'development'
    ? React.lazy(() =>
        import('@tanstack/react-query-devtools').then((m) => ({default: m.ReactQueryDevtools}))
      )
    : null

const defaultOptions: DefaultOptions = {
  queries: {
    retry: (failureCount, error) => {
      if (error.response?.status === 404) {
        return false
      }
      return failureCount < 3
    }
  }
}

const queryClient = new QueryClient({defaultOptions})

export const SuiteQueryProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {ReactQueryDevtools ? (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      ) : null}
    </QueryClientProvider>
  )
}
